import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 67B4875F-B08F-4006-AFE1-9C243F8B873A
 * name table-column-plus-before
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/table-column-plus-before.svg
 * tags
 * - Text / Content / Format 
 */
export const TableColumnPlusBeforeIcon = createSvgIcon(<><path d="M13,2A2,2 0 0,0 11,4V20A2,2 0 0,0 13,22H22V2H13M20,10V14H13V10H20M20,16V20H13V16H20M20,4V8H13V4H20M9,11H6V8H4V11H1V13H4V16H6V13H9V11Z" /></>, 'TableColumnPlusBeforeIcon');
export default TableColumnPlusBeforeIcon